import actionsTypes from './actionTypes';
import { IMetabaseState, ILoadDataSuccessPayload } from './types';
import { createReducer } from '../../helpers/reducer';

const initState: IMetabaseState = {
  isLoading: false,
  settings: undefined,
};

function onLoadSettingsRequest(state: IMetabaseState): IMetabaseState {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadSettingsSuccess(
  state: IMetabaseState,
  { payload }: { payload: ILoadDataSuccessPayload },
): IMetabaseState {
  return {
    ...state,
    isLoading: false,

    settings: {
      dashboard: payload.dashboard,
    },
  };
}

function onLoadSettingsError(state: IMetabaseState): IMetabaseState {
  return {
    ...state,
    isLoading: false,
  };
}

export default createReducer(initState, {
  [actionsTypes.LOAD_METABASE_REQUEST]: onLoadSettingsRequest,
  [actionsTypes.LOAD_METABASE_SUCCESS]: onLoadSettingsSuccess,
  [actionsTypes.LOAD_METABASE_ERROR]: onLoadSettingsError,
});
